import request from '@/utils/request'

const prefix = '/django_rest/company/applicant-status-notification-template-config'

export default {
  getCompanyApplicantStatusNotificationTemplateConfig (companyId, params) {
    return request.get(`${prefix}/${companyId}/`, { params })
  },
  createApplicantStatusNotificationTemplateConfig (companyId, config) {
    return request.post(`${prefix}/${companyId}/`, config)
  },
  updateApplicantStatusNotificationTemplateConfig (companyId, config) {
    return request.put(`${prefix}/${companyId}/`, config)
  },
  deleteApplicantStatusNotificationTemplateConfig (companyId) {
    return request.delete(`${prefix}/${companyId}/`)
  },
  getCompanyApplicantStatusEmailTemplateList (companyId) {
    return request.get(`/django_rest/company/applicant-status-email-template/${companyId}/`)
  }
}
